export interface I_SisStreaming {
  format: string;
  url: string;
}
